package ff.util

import ff.log.trace
import kotlinx.browser.window
import kotlin.js.Promise

fun sleep(ms: Int) = Promise.Companion.resolve { window.setTimeout({ trace("slept for $ms")  }, ms) }